import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';
import WdPageSimple from '@main/core/WdPageSimple';
import { ComposedHeader } from '@main/components';

const Root = styled(WdPageSimple)(({ theme }) => ({
  '& .WdPageSimple-header': {},
  '& .WdPageSimple-content': {},
}));

const Configuration = () => {
  return (
    <Root
      header={
        <ComposedHeader
          decorator="button"
          title="Configuracion general"
          description="Configuracion de manager"
        />
      }
      content={
        <Grid container spacing={6} className="p-32">
          <Grid item xs={12} md={12}>
            <div className="bg-orange-500">
              <p>
                <span>Put your content here</span>
              </p>
            </div>
          </Grid>
        </Grid>
      }
    />
  );
};

export default Configuration;

